<template>
    <div>
        <b-row v-if="!printView || refunds.length">
            <b-col class="header-menu-text">
                <h5 class="text-secondary" v-if="refunds.length === 1">Refund</h5>
                <h5 class="text-secondary" v-else>Refunds</h5>
            </b-col>

            <b-col align="right" v-if="!printView">
                <b-dropdown ref="refundDropdown" no-caret size="sm" variant="link" class="menu-btn" toggle-class="text-decoration-none">
                    <template #button-content>
                        <b-button variant="outline-secondary" size="sm">
                            <b-icon-plus></b-icon-plus>
                        </b-button>
                    </template>

                    <refund @addRefund="addRefund(null, $event)"></refund>
                </b-dropdown>
            </b-col>
        </b-row>

        <div v-if="!printView">
            <b-row v-if="component.length < 1">
                <b-col align="center">
                    <b-list-group>
                        <b-list-group-item variant="light">
                            <small><em>No Refunds</em></small>
                        </b-list-group-item>
                    </b-list-group>
                </b-col>
            </b-row>

            <b-row v-for="(refund, index) in component" :key="'refund-' + index" class="mb-3">
                <b-col>
                    <b-input-group size="sm" :prepend="refund.type">
                        <b-input class="py-3" :value="'$' + refund.amount" disabled></b-input>

                        <b-input-group-append v-if="refund.username">
                            <b-button size="sm" :id="'refunduser-' + index" variant="outline-info">
                                <b-icon-person></b-icon-person>
                            </b-button>
                            <b-tooltip :target="'refunduser-' + index" triggers="hover">
                                {{ refund.username }}
                            </b-tooltip>
                        </b-input-group-append>

                        <b-input-group-append v-if="refund.date">
                            <b-button size="sm" :id="'refunddate-' + index" variant="outline-info">
                                <b-icon-calendar4-event></b-icon-calendar4-event>
                            </b-button>
                            <b-tooltip :target="'refunddate-' + index" triggers="hover">
                                {{ moment(refund.date).format('M/D/YYYY h:mma') }}
                            </b-tooltip>
                        </b-input-group-append>

                        <b-input-group-append>
                            <b-dropdown ref="existingRefundDropdown" no-caret size="sm" variant="outline-info" toggle-class="text-decoration-none">
                                <template #button-content>
                                    <b-button class="editButton p-0" variant="outline-info" size="sm">
                                        <b-icon-pencil></b-icon-pencil>
                                    </b-button>
                                </template>
                                <refund
                                    :initialAmount="refund.amount"
                                    :initialType="refund.type"
                                    :initialNote="refund.note"
                                    :isExisting="true"
                                    @addRefund="addRefund(index, $event)"
                                    @removeRefund="removeRefund(index)"
                                ></refund>
                            </b-dropdown>
                        </b-input-group-append>
                    </b-input-group>

                    <b-input-group size="sm" v-if="refund.note">
                        <em class="form-control disabled">{{ refund.note }}</em>
                    </b-input-group>
                </b-col>
            </b-row>
        </div>

        <div v-else>
            <div v-for="(refund, index) in refunds" :key="'refund-' + index">
                <b-row>
                    <b-col sm="3">Type</b-col>
                    <b-col>{{ refund.type }}</b-col>
                </b-row>
                <b-row>
                    <b-col sm="3">Date</b-col>
                    <b-col>{{ moment(refund.date).format('M/D/YYYY h:mma') }}</b-col>
                </b-row>
                <b-row>
                    <b-col sm="3">Amount</b-col>
                    <b-col>${{ refund.amount }}</b-col>
                </b-row>
                <b-row v-if="refund.refundId">
                    <b-col sm="3">Refund ID</b-col>
                    <b-col>{{ refund.refundId }}</b-col>
                </b-row>
                <b-row v-if="refund.paymentTransactionId">
                    <b-col sm="3">Payment Txn ID</b-col>
                    <b-col>{{ refund.paymentTransactionId }}</b-col>
                </b-row>
                <b-row v-if="refund.note">
                    <b-col sm="3">Note</b-col>
                    <b-col>{{ refund.note }}</b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import Refund from "./Refund";
    import arrayMixin from "../../mixins/array";

    export default {
        name: "RefundList",
        props: [ 'refunds', 'printView' ],
        mixins: [ arrayMixin ],
        components: { Refund },
        data() {
            return { moment };
        },
        created() {
            this.clone(this.refunds || []);
        },
        watch: {
            refunds: {
                handler(newVal) {
                    const refs = newVal || [];
                    if (refs.length !== this.component.length) {
                        this.clone(refs);
                    }
                },
                deep: false,
            },
        },
        methods: {
            addRefund(index, refund) {
                if (index !== null && index !== undefined) {
                    const updatedArray = this.component.map((item, i) => i === index ? refund : item);
                    this.component = updatedArray;
                } else {
                    this.component.push(refund);
                }
                this.$emit('update', this.component);
                this.closeDropdown(index);
            },
            removeRefund(index) {
                this.component.splice(index, 1);
                this.$emit('update', this.component);
                this.closeDropdown(index);
            },
            closeDropdown(index) {
                if (index !== null && index !== undefined) {
                    (this.$refs.existingRefundDropdown || [])[index]?.hide();
                } else {
                    this.$refs.refundDropdown?.hide();
                }
            }
        }
    };
</script>

<style scoped>
    .editButton {
        border: none;
    }
    .input-group-text {
        width: 8rem;
    }
    .list-group-item {
        padding: 0.25rem .5rem;
    }
</style>
